import React from 'react';
import { FiBarChart2 } from 'react-icons/fi';
import { useT } from '../utils/i18n';

export const Analysis10 = () => {
  const t = useT();
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
          <FiBarChart2 size={20} className="text-primary-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{t('page.analysis10.title')}</h1>
          <p className="text-sm text-gray-500">{t('page.analysis10.desc')}</p>
        </div>
      </div>
      <div className="card flex flex-col items-center justify-center h-64 gap-3 text-gray-400">
        <FiBarChart2 size={40} className="text-gray-300" />
        <p className="text-lg font-medium">{t('page.comingSoon')}</p>
        <p className="text-sm">{t('page.editorBeingBuilt')}</p>
      </div>
    </div>
  );
};
